import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { ImpersonationBanner } from './ImpersonationBanner'
import { TenantLocaleSync } from '@/components/TenantLocaleSync'
import { TenantBrandSync } from '@/components/TenantBrandSync'
import { BackToChatBanner } from '@/features/chatbot/BackToChatBanner'

/**
 * The single layout used for every authenticated page. Sidebar + Header
 * mount once; `<Outlet/>` swaps page content without remounting chrome.
 * This is what eliminates the legacy "every page rebuilds the sidebar"
 * pattern.
 */
export function AppShell() {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-background">
      <TenantLocaleSync />
      <TenantBrandSync />
      <div className="hidden md:block">
        <Sidebar />
      </div>
      <div className="flex h-screen w-full min-w-0 flex-1 flex-col overflow-hidden">
        <Header />
        <ImpersonationBanner />
        {/*
          ─────────────────────────────────────────────────────────────
          CANONICAL PAGE SPACING - DO NOT DUPLICATE ELSEWHERE
          ─────────────────────────────────────────────────────────────
          The gap between the sidebar/header and every page's content
          lives ON THIS ELEMENT, and only on this element. Every route
          renders into <Outlet /> below and inherits it for free, which
          is what guarantees Dashboard, Branding, Profile, Invoices,
          Smart Chat, Reports, etc. all sit the same distance from the
          chrome.

          Rules for any page (current or new):
            • Don't add px-/py- to the page's outermost wrapper. <Page>
              and the chatbot wrapper deliberately omit them.
            • Don't add mx-auto on the outermost wrapper either - it
              would re-center constrained content and break the flush-
              left alignment with the sidebar.
            • If a page needs a different left/right gap (it shouldn't),
              fix it HERE so every page picks it up at once.
          See CLAUDE.md "Frontend conventions → Page-level spacing".
          ─────────────────────────────────────────────────────────────
        */}
        <main className="flex-1 overflow-y-auto px-4 py-6 sm:px-6 lg:px-10">
          {/* Renders only when ?fromChat=<threadId> is in the URL -
              auto-shows on resource-detail pages opened from a chat
              citation, hides everywhere else (including on /chatbot
              itself, see component for the early return). */}
          <BackToChatBanner />
          <Outlet />
        </main>
      </div>
    </div>
  )
}
